<template>
  <button
    :type="buttonType"
    class="buttonTypeCustom"
    :class="[buttonColor, buttonSize, { isPc: !isSp, buttonNoMaxWidth: buttonNoMaxWidth, maxWidthNone: maxWidthNone }]"
    @click="clicked($event)"
    @mousedown="onMousedown"
  >
    {{ buttonText }}
  </button>
</template>

<script>
export const BUTTON_COLOR_LIST = {
  DEFAULT: 'colorDefault',
  SECONDARY: 'colorSecondry',
  PRIMARY: 'colorPrimary',
  PRIMARY_BORDER: 'colorPrimaryBorder',
  CTA: 'colorCta',
  CANCEL: 'colorCancel',
};

export default {
  name: 'ButtonTypeCustom',
  props: {
    buttonType: {
      required: false,
      default: 'button',
      validator(value) {
        return ['submit', 'reset', 'button'].indexOf(value) !== -1;
      },
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonColor: {
      required: false,
      default: 'colorDefault',
      validator(value) {
        return Object.values(BUTTON_COLOR_LIST).indexOf(value) !== -1;
      },
    },
    buttonSize: {
      required: false,
      default: 'sizeMedium',
      validator(value) {
        return ['sizeLarge', 'sizeMedium', 'sizeSmall'].indexOf(value) !== -1;
      },
    },
    buttonNoMaxWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    maxWidthNone: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
  methods: {
    clicked(event) {
      if (this.buttonType !== 'button') return;

      this.$emit('button-clicked', event);
    },
    onMousedown(event) {
      this.$emit('mousedown', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.buttonTypeCustom {
  margin: 0 auto;
  border: 0;
  display: block;
  line-height: 1;
  outline: none;
  width: 100%;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;

  &.isPc {
    margin: 0 auto;
    max-width: 360px;

    &.maxWidthNone {
      max-width: none;
    }
  }

  &.buttonNoMaxWidth {
    max-width: none;
  }
}

.sizeLarge {
  height: 48px;
  font-size: 18px;
}

.sizeMedium {
  height: 40px;
  font-size: 16px;
}

.sizeSmall {
  height: 32px;
  font-size: 14px;
}

@mixin hoverView {
  &:hover {
    opacity: 0.7;
  }
}

.colorDefault {
  color: $color-action-spot-action-light;
  border: solid 1px $color-action-spot-action-light;
  background: $color-background-primary-third-light;

  @include hoverView;
}

.colorSecondry {
  color: $color-action-secondry;
  border: solid 1px $color-action-secondry;
  background: $color-background-primary-third-light;

  @include hoverView;
}

.colorPrimary {
  color: #fff;
  background: $color-action-primary;

  @include hoverView;
}

.colorPrimaryBorder {
  color: $color-action-primary;
  border: solid 1px $color-action-primary;
  background: $color-background-primary-third-light;

  @include hoverView;
}

.colorCta {
  color: #fff;
  background: $color-action-cta;

  &:hover {
    background-color: #ffab4d;
  }
}

.colorCancel {
  color: $color-text-secondry;
  border: $border-sapuri-white-light;
  background: $color-background-primary-third-light;

  @include hoverView;
}
</style>
